import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

/**
 * The template editor is deep-linkable: the URL decides which editor is open.
 *   `?compose=1`   → create a new template
 *   `?edit=<id>`   → edit a specific template
 */
export interface AdminEmailSearch {
  compose?: boolean;
  edit?: string;
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  component: AdminEmailPage,
  validateSearch: (search: Record<string, unknown>): AdminEmailSearch => ({
    compose:
      search.compose === true || search.compose === "1" || search.compose === "true"
        ? true
        : undefined,
    edit: typeof search.edit === "string" && search.edit.trim() !== "" ? search.edit : undefined,
  }),
});
